module.exports = __webpack_public_path__ + "img/tabbar_18.40805f16.png";